import * as React from "react";
import SuccessUploadShare from "../../Components/UploadAndShare/success";

export const UploadAndShareComponent = () => {
  return (
    <>
      <SuccessUploadShare title={"Upload & Share"} />
    </>
  );
};

export default UploadAndShareComponent;
